<template>
  <div class="menu-box">
    <div class="banner">
      <img src="@/assets/banner.png" style="width:100%;height:100%" alt />
      <div class="banner_title">XXXXXXXXXXXXXXXX</div>
      <div class="banner_text">XXXXXXXXXXXXXXXX</div>
    </div>
    <div class="menu-wrap">
      <div class="menu-list">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item
            v-for="item in menuList"
            :key="item.index"
            :index="item.index"
          >{{ item.name }}</el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="apply-wrap" v-if="false">
      <img style="width: 160px;height:146px" src="@/assets/images/empty_info.png" alt />
      <div class="apply_text">您还未注册企业信息，无法申报项目，请您尽快完成信息注册</div>
      <el-button type="primary" style="background: #0758FF;" @click="routeJump">单位注册</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "NavbarPage",
  data() {
    return {
      activeIndex: "0",
      menuList: [
        { name: "项目申报", index: "0", path: "/xmsb" },
      ]
    };
  },
  computed:{
    ...mapState({}),
  },
  watch:{
    $route:{
      handler(val){
        const path = val.path;
        this.activeIndex = this.menuList.filter(item=>item.path === path)[0]?.index;
      },immediate:true,
      deep:true
    },
  },
  methods: {
    handleSelect(e) {
      this.$router.push(this.menuList[e].path);
    },
    routeJump(){
      this.$router.push('/register');
    },
  }
};
</script>

<style lang="scss" scoped>
.menu {
  &-wrap {
    background: #ffffff;
    ::v-deep {
      .el-menu.el-menu--horizontal {
        border-bottom: none;
      }
    }
    margin-bottom: 20px;
  }
  &-list {
    width: 1200px;
    margin: 0 auto;
  }
}
.banner {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 160px;
  &_title {
    position: absolute;
    z-index: 1;
    top: 57px;
    left: 360px;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    line-height: 18px;
  }
  &_text {
    position: absolute;
    z-index: 1;
    top: 90px;
    left: 360px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 14px;
  }
}
.apply {
  &-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 1200px;
    height: 591px;
    margin: 0 auto;
    background: #ffffff;
  }
  &_text {
    font-weight: 400;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    margin: 10px 0 30px;
  }
}
</style>